<template>
  <KTPortlet :title="title">
    <template v-slot:body>
      <div class="d-flex justify-content-between">
        <b-button id="go-back" type="button" @click="back" variant="secondary"
          >Go Back</b-button
        >
        <b-button
          id="confirm"
          type="button"
          @click.once="confirm"
          variant="primary"
          >Confirm</b-button
        >
      </div>

      <div class="kt-wizard-v2">
        <div class="kt-wizard-v2__wrapper" style="background-color: white">
          <div class="kt-form" style="border: 0px">
            <div class="kt-wizard-v2__content" style="background-color: white">
              <div class="kt-form__section kt-form__section--first">
                <div class="kt-wizard-v2__review">
                  <div
                    id="recurring-information"
                    class="kt-wizard-v2__review-item"
                  >
                    <div class="kt-wizard-v2__review-title">
                      <h4>Recurring Payment Information</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <label for="execudate">Date of First Payment: </label>
                      <p name="execudate">{{ executionDate }}</p>
                      <label for="freq">Frequency of Payments: </label>
                      <p name="freq">{{ frequencyText }}</p>
                      <label for="paydesc">Payment Description: </label>
                      <p name="first">{{ form.recurringInformation.reason }}</p>
                    </div>
                  </div>
                  <div id="order-information" class="kt-wizard-v2__review-item">
                    <div class="kt-wizard-v2__review-title">
                      <h4>Order Information</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <label for="first">First Name: </label>
                      <p name="first">{{ form.orderInformation.firstName }}</p>

                      <label for="last">Last Name: </label>
                      <p name="last">{{ form.orderInformation.lastName }}</p>

                      <label for="em">Email: </label>
                      <p name="em">{{ form.orderInformation.email }}</p>

                      <label for="ord">Order Number: </label>
                      <p name="ord">{{ form.orderInformation.orderNumber }}</p>

                      <label for="curr">Currency: </label>
                      <p name="curr">{{ form.orderDetails.currency }}</p>

                      <!-- Promocode Details -->
                      <template v-if="promoCodeDetails.success">
                        <!-- Code name -->
                        <label for="promocodeName">Promocode: </label>
                        <p name="promocodeName">
                          {{ promoCodeDetails.code }}
                        </p>

                        <!-- Code description -->
                        <template v-if="promoCodeDetails.description">
                          <label for="PromocodeDescription"
                            >Promocode Description:
                          </label>
                          <p name="PromocodeDescription">
                            {{ promoCodeDetails.description }}
                          </p>
                        </template>

                        <!-- Normal Discount -->
                        <template v-if="promoCodeDetails.discount"
                          ><label for="initialDiscount"
                            >Initial Discount:
                          </label>
                          <p name="initialDiscount">
                            {{ formattedinitialPaymentAmountDiscount }}
                          </p></template
                        >

                        <!-- Recurring Discount -->
                        <template v-if="promoCodeDetails.recurring.discount">
                          <label for="recurringDiscount"
                            >Recurring Discount:
                          </label>
                          <p name="recurringDiscount">
                            {{ formattedRecurringAmountDiscount }}
                          </p>
                        </template>
                      </template>

                      <label for="ini">Initial Payment: </label>
                      <p name="ini">${{ initialPaymentAmount }}</p>

                      <label for="ini">Subsequent Payments: </label>
                      <p name="ini">${{ recurringAmount }}</p>

                      <!-- Promocode Free Trial Message -->
                      <template v-if="promoCodeDetails.success">
                        <template v-if="promoCodeDetails.recurring.freeTrial">
                          <label for="freeTrialMessage">Free Trial: </label>
                          <p name="freeTrialMessage">
                            {{ freeTrialMessage }}
                          </p></template
                        >
                      </template>
                    </div>
                  </div>
                  <div
                    v-if="customFields && customFields.length"
                    id="additional-information"
                    class="kt-wizard-v2__review-item"
                  >
                    <div class="kt-wizard-v2__review-title">
                      <h4>Additional Information</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <div
                        v-for="(property, index) in customFields"
                        :key="index"
                      >
                        <label :for="property.label"
                          >{{ property.label }}:
                        </label>
                        <p :name="property.label">
                          {{ form.customFieldsModel[property.fieldName] }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    id="billing-information"
                    class="kt-wizard-v2__review-item"
                  >
                    <div class="kt-wizard-v2__review-title">
                      <h4>Billing Information</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <label for="ad1">Address 1: </label>
                      <p name="ad1">{{ form.billingInfo.Address1 }}</p>

                      <label for="ad2">Address 2: </label>
                      <p name="ad2">{{ form.billingInfo.Address2 }}</p>

                      <label for="city">City: </label>
                      <p name="city">{{ form.billingInfo.City }}</p>

                      <label for="country">Country: </label>
                      <p name="country">{{ form.billingInfo.Country }}</p>
                    </div>
                  </div>
                  <div id="card-information" class="kt-wizard-v2__review-item">
                    <div class="kt-wizard-v2__review-title">
                      <h4>Credit Card Information</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <label for="cardnum">Card Number: </label>
                      <p name="cardnum">xxxx xxxx xxxx {{ cardNumber }}</p>

                      <label for="cardname">Card Name: </label>
                      <p name="cardname">
                        {{ form.creditCardInfo.cardHolderName }}
                      </p>

                      <label for="cardtype">Card Type: </label>
                      <p name="cardtype">
                        {{ form.creditCardInfo.cardType.text }}
                      </p>

                      <label for="exp">Card Expiry: </label>
                      <p name="exp">{{ form.creditCardInfo.expiryDate }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!--
    <template v-slot:foot>
      <div class="d-flex justify-content-between">
        <b-button id="go-back" type="button" @click="back" variant="primary"
          >Go Back</b-button
        >
        <b-button id="confirm" type="button" @click="confirm" variant="primary"
          >Confirm</b-button
        >
      </div>
    </template>-->
  </KTPortlet>
</template>

<script>
import KTPortlet from "@/views/partials/content/Portlet";
import { currencyFormat, awsDateToDate } from "@/services/Formatting.js";

export default {
  components: {
    KTPortlet
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    customFields: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      required: false,
      default: "Review your Details and Submit"
    },
    paymentFrequencies: {
      type: Object,
      default() {
        return {
          Daily: "Daily",
          Weekly: "Weekly",
          Fortnightly: "Fortnightly/Bi-Weekly",
          Monthly: "Monthly",
          BiMonthly: "Bi-Monthly",
          Quarterly: "Quarterly",
          Yearly: "Yearly"
        };
      }
    },
    promoCodeDetails: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedRecurringfrequency() {
      if (!this.promoCodeDetails.recurring.freeTrial) return null;

      switch (this.promoCodeDetails.recurring.freeTrial.frequency) {
        case "Daily":
          return "days";
        case "Weekly":
          return "weeks";
        case "Fortnightly":
          return "fortnights";
        case "Monthly":
          return "months";
        case "BiMonthly":
          return "bimonths";
        case "Quarterly":
          return "quarters";
        case "Yearly":
          return "years";
        default:
          return null;
      }
    },
    freeTrialMessage() {
      if (!this.promoCodeDetails.recurring.freeTrial) return null;
      return `The first ${this.promoCodeDetails.recurring.freeTrial.period} ${this.formattedRecurringfrequency} of your payment will be free.`;
    },
    cardNumber() {
      let lastSpace = this.form.creditCardInfo.cnumber.lastIndexOf(" ");

      return this.form.creditCardInfo.cnumber.substring(lastSpace);
    },
    initialPaymentAmountDiscount() {
      const value = this.promoCodeDetails;
      if (!value.success) return 0;
      if (!value.discount) return 0;
      if (value.discount.type == "Percentage") {
        return (
          this.form.orderDetails.initialPaymentAmount *
          (value.discount.amount / 100)
        );
      }
      return value.discount.amount;
    },
    formattedinitialPaymentAmountDiscount() {
      if (!this.initialPaymentAmountDiscount) return null;
      return `- $${currencyFormat(this.initialPaymentAmountDiscount)}`;
    },
    recurringAmountDiscount() {
      const value = this.promoCodeDetails;
      if (!value.success) return 0;
      if (!value.recurring.discount) return 0;
      if (value.recurring.discount.type == "Percentage") {
        return (
          this.form.orderDetails.amount *
          (value.recurring.discount.amount / 100)
        );
      }
      return value.recurring.discount.amount;
    },
    formattedRecurringAmountDiscount() {
      if (!this.recurringAmountDiscount) return null;
      return `- $${currencyFormat(this.recurringAmountDiscount)}`;
    },

    initialPaymentAmount() {
      return currencyFormat(
        this.form.orderDetails.initialPaymentAmount -
          this.initialPaymentAmountDiscount
      );
    },

    recurringAmount() {
      return currencyFormat(
        this.form.orderDetails.total - this.recurringAmountDiscount
      );
    },
    discounts() {
      return this.form.orderDetails.discounts.map(d => {
        return { ...d, Amount: currencyFormat(d.Amount) };
      });
    },
    frequencyText() {
      return this.paymentFrequencies[this.form.recurringInformation.frequency];
    },
    executionDate() {
      const executionDateString = this.form.recurringInformation.executionDate;
      if (!executionDateString) return "Immediate";

      const date = awsDateToDate(executionDateString);
      return date.toDateString();
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    back() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Open Sans", sans-serif;
}
label {
  /* Other styling... */

  clear: both;
  float: left;
  font-weight: 700;
  font-size: 14px;
}

.kt-wizard-v2__review-content {
  display: grid !important;
  grid-template-columns: 1fr 3fr !important;
}
p {
  font-size: 14px;
}

div.container {
  margin: 5% 10% 5% 0% !important;
}

.review-information {
  border-style: solid;
  border-width: 1px 0px 1px 0px;
  padding: 3% 1% 3% 1%;
  min-width: 100%;
}
h4 {
  margin-bottom: 4%;
}
</style>
